// extracted by mini-css-extract-plugin
export default {"wrap":"MobileBackward_wrap__1rH2G"};